export default "__VITE_ASSET__CkO7UiwN__"